import type { Collection } from "../../server/utils";

const collections = ref<Collection[]>([]);

// Set of artwork IDs that are saved in *any* collection for quick lookup
const localSavedItems = computed(() => {
  const items = new Set<string>();
  collections.value.forEach(c => {
    if (Array.isArray(c?.items)) {
      c.items.forEach(i => items.add(i));
    }
  });
  return items;
});

const localSavedItemsCount = computed(() => {
  return localSavedItems.value.size;
});

const isSaveModalOpen = ref(false);
const activeArtworkIdForModal = ref<string | null>(null);

const isRsvpModalOpen = ref(false);
const rsvpEmail = ref('');
const rsvpArtworkId = ref('');

const isPaymentSuccessModalOpen = ref(false);
const isProcessingPayment = ref(false);
const completedOrderData = ref<{
  orderId?: string;
  rpOrderId?: string;
  rpPaymentId?: string;
  artworkId?: string;
  artworkName?: string;
  artistName?: string;
  photoName?: string;
  setId?: number;
  isCartCheckout?: boolean;
  cartItems?: any[];
  customerName?: string;
  customerEmail?: string;
  amount?: number;
} | null>(null);

const landingShuffledArtists = ref<any[]>([]);
const landingShuffledArtworks = ref<any[]>([]);

export function useAppState() {
  return {
    collections,
    localSavedItems,
    localSavedItemsCount,
    isSaveModalOpen,
    activeArtworkIdForModal,
    isRsvpModalOpen,
    rsvpEmail,
    rsvpArtworkId,
    isPaymentSuccessModalOpen,
    isProcessingPayment,
    completedOrderData,
    landingShuffledArtists,
    landingShuffledArtworks,
  };
}
